// removed by extract-text-webpack-plugin
module.exports = {"post-heading":"src-styles----post-module---post-heading---3XY_J","post-heading__title":"src-styles----post-module---post-heading__title---1-9YQ","post-heading__meta":"src-styles----post-module---post-heading__meta---3katd","donation":"src-styles----post-module---donation---1rPSR","pager":"src-styles----post-module---pager---3ag2f","pager__item":"src-styles----post-module---pager__item---vNI-Q","pager__title":"src-styles----post-module---pager__title---2ZGsj","pager__tips":"src-styles----post-module---pager__tips---R2YkG","pager__item--disabled":"src-styles----post-module---pager__item--disabled---XSQC6"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/post.module.css
// module id = 257
// module chunks = 213130420965792